/**
 * A thin band on every page outside production ("Staging — test data, no real
 * money") so nobody mistakes the test system for the real one.
 */
const ENV = String(import.meta.env.VITE_APP_ENV || "").toLowerCase();

export default function EnvRibbon() {
  if (!ENV || ENV === "production" || ENV === "development") return null;
  return (
    <div role="note" className="pointer-events-none fixed inset-x-0 top-0 z-[100] flex justify-center">
      <span className="rounded-b-md bg-amber-500 px-3 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-amber-950 shadow">
        {ENV} — test data, no real money
      </span>
    </div>
  );
}
